import {Component} from "@angular/core";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {WelcomeApiService} from "../../../core/api/welcome-api.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {AppMessageService} from "../../../core/service/app-message.service";
import {SettingsService} from "../../service/settings.service";


@Component({
  selector: 'terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent extends CoreComponent {

  termsOfUse: string | undefined;

  constructor(
    protected settingService: SettingsService,
    protected router: Router,
    protected welcomeApiService: WelcomeApiService,
    protected messageService: AppMessageService,
    protected formBuilder: FormBuilder,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.settingService.setHeader('Erstinformation', 'Wer wir sind und wie wir arbeiten.');
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.getTermsOfUse();
    this.refreshComponent();
  }

  getTermsOfUse() {
    this.welcomeApiService.getTermsOfUse().subscribe(res => {
      this.termsOfUse = res.replace(/&nbsp;/g, ' ');
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);

    })
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }


}
